import React, {Component,Fragment} from 'react';
import { ACCESS_TOKEN ,SESSION_USER,SSO_PARAMS} from '../../constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FormValidation } from "calidation";
import { login } from '../../util/APIUtils';
class Login extends Component {

  constructor(props) {
        super(props);
         //alert(localStorage.getItem(ACCESS_TOKEN));
         localStorage.removeItem(ACCESS_TOKEN);
         localStorage.removeItem(SESSION_USER);
         localStorage.removeItem(SSO_PARAMS);
       
  }
  
    componentDidMount() {
      //localStorage.removeItem(ACCESS_TOKEN);
  }
 onSubmit = ({ fields, errors, isValid }) => {         
        if (isValid) { 
       // console.log(fields);
       // return false;          
                 login(fields)
                .then(response => {
                 //  console.log(response);
                   localStorage.setItem(ACCESS_TOKEN, response.accessToken);
                 //  toast.success('Successfully Login!',{autoClose: false,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});
                   this.props.onLogin();
                }).catch(error => {
                    if(error.status === 401) {
                         toast.error('Your Username or Password is incorrect. Please try again!',{autoClose: 10000,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});         
                    } else {
                           toast.error(error.message || 'Sorry! Something went wrong. Please try again!',{autoClose: 10000,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});                                        
                    }
                });  
        }
  };

    render() {
        /* const divStyle = {
             backgroundImage:'url(./static/assets/images/background/login-register.jpg)',
         };*/

          const errorStyle = {
                color: "#fc4b6c"
          }
         const config = {
                usernameOrEmail: {
                    isRequired: "field is required!"
                },
                password: {
                    isRequired: "field is required!"
                }
         };
 return (

    

<div id="wrappers" >
 <ToastContainer />
    <div className="login-register" >    
            <div className="login-box card">
                        <div className="card-body">
                    <FormValidation className="form-horizontal form-material" onSubmit={this.onSubmit} config={config}>
                    {({ fields, errors, submitted }) => (
                        <Fragment>
<h3 className="box-title m-b-20">Sign In</h3>
                    <div className="form-group ">
                        <div className="col-xs-12">
                            <input className="form-control" name="usernameOrEmail" type="text" required="" placeholder="Username or Email" /> </div>
                             {submitted && errors.usernameOrEmail &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.usernameOrEmail}</small>
                             }
                    </div>
                    <div className="form-group">
                        <div className="col-xs-12">
                            <input className="form-control" type="password" name="password" required="" placeholder="Password" /> </div>
                             {submitted && errors.password &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.password}</small>
                             }
                    </div>
                    
                    <div className="form-group text-center m-t-20">
                        <div className="col-xs-12">
                            <button className="btn-rounded btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Log In</button>
                        </div>
                    </div>
                    
                    <div className="form-group m-b-0">
                        <div className="col-sm-12 text-center">
                            <p>Don't have an account? <a href="/signup" className="text-info m-l-5"><b>Sign Up</b></a></p>
                        </div>
                    </div>


                        </Fragment>
                        )}
                   </FormValidation>       
                   
                          
                        
                        </div>
            </div>
     </div>   
</div>
 );
}
}
export default Login;